import { Common, color } from '@stockbit/ui';
import { LabelAdmin, LabelVerifiedAccount } from 'global/Labels';
import { parseISO, format } from 'date-fns';
import Link from 'next/link';
import StreamItemOption from 'global/StreamWidget/Post/StreamItemOption';
import { StreamPostData } from '../../../../@types/stream';
import { TextHeader } from '../ItemConversation/styled';
import UserAvatar from '../ItemConversation/Avatar';
import { HeaderContent } from '../styled';

const { Flex, Text } = Common;

interface HeaderProps {
  post: StreamPostData;
  handleClose: () => void;
}

function Header({ post, handleClose }: HeaderProps) {
  const {
    avatar,
    username,
    official,
    saved,
    follow,
    postid,
    userid,
    user_priv: privilege,
    created_display: created,
    updated,
    polling,
  } = post;
  const isFollowed: boolean = follow === 1;

  const hasEdited: boolean = updated !== '0000-00-00 00:00:00';
  const isPolling: boolean = polling.length > 0;

  return (
    <Flex width="100%">
      <UserAvatar
        avatar={avatar}
        avatarSize="medium"
        username={username}
        showPopover={false}
      />
      <HeaderContent>
        <div>
          <Flex align="center">
            <Link href={`/${username}`}>
              <a style={{ color: 'unset' }}>
                <TextHeader size="16px" family="bold">
                  {username}
                </TextHeader>
              </a>
            </Link>
            <Flex align="center" height="16px">
              <LabelVerifiedAccount
                deprecatedVerifiedStatus={official > 0}
                verifiedStatus={post?.verified_status}
              />
              <LabelAdmin privilege={privilege} />
            </Flex>
          </Flex>
          <Text size="12px" color={color.midgray}>
            {created}
            {hasEdited
              ? ` Edited on ${format(parseISO(updated), 'd MMM yy, HH:mm')}`
              : null}
          </Text>
        </div>
        <StreamItemOption
          userId={userid}
          postId={postid}
          post={post}
          saved={saved}
          followed={isFollowed}
          isPolling={isPolling}
          type="post"
          handleCloseConvo={handleClose}
          showFollowNotification
          entryPoint="conversation"
        />
      </HeaderContent>
    </Flex>
  );
}

export default Header;
